import { AiOutlineLoading } from "react-icons/ai";
import { ButtonHTMLAttributes, CSSProperties, FC, ReactNode } from "react";
import "./Button.css";

interface Props {
  text: any;
  isLoading?: boolean;
  onClick?: () => void;
  type?: "primary" | "secondary" | "muted" | "danger" | "transparent";
  className?: string;
  LeftIcon?: ReactNode;
  RightIcon?: ReactNode;
  style?: CSSProperties;
  key?: string;
  disabled?: boolean;
  buttonType?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
}

export const btnStyle =
  "bg-PRIMARY rounded-md py-2 px-8 border font-Medium text-lg text-white cursor-pointer";

const Button: FC<Props> = ({
  text,
  key,
  onClick,
  type,
  className,
  RightIcon,
  LeftIcon,
  style,
  disabled = false,
  isLoading = false,
  buttonType = "button",
}) => {
  const onClickHandler = () => {
    // if not loading, emit the event
    if (!isLoading && onClick) {
      onClick();
    }
  };

  const typeBasedStyles = () => {
    switch (type) {
      case "secondary":
        return "border border-MAIN_TEXT hover:border-transparent bg-transparent hover:bg-PRIMARY  text-MAIN_TEXT hover:text-white";
      case "danger":
        return "bg-RED";
      case "muted":
        return "bg-MUTED_TEXT ";
      case "transparent":
        return "bg-transparent border-0 text-PRIMARY";
      default:
        break;
    }
  };

  return (
    <button
      key={key}
      style={style}
      data-testid="btn"
      type={buttonType}
      disabled={disabled}
      onClick={onClickHandler}
      className={`${btnStyle} ${type} my-5 Button ${typeBasedStyles()} ${className} relative flex items-center justify-center hover:opacity-90`}
    >
      {LeftIcon}
      <AiOutlineLoading
        onClick={onClickHandler}
        className={`animate-spin mx-2 my-1 absolute ${
          !isLoading && "opacity-0"
        }`}
      />
      <span
        onClick={onClickHandler}
        className={`${isLoading && "opacity-0"} cursor-pointer`}
      >
        {text}
      </span>
      {RightIcon}
    </button>
  );
};

export default Button;
